import styled from 'styled-components';
import HappyDropDownSvg from './happyDropDown.svg';

const HappyDropDownIcon = styled(HappyDropDownSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  margin: ${props => props.margin};
  fill: ${props => props.fill || props.theme.colors.ash.base};
`;

export default HappyDropDownIcon;
